import React from 'react'

import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import { faChevronRight } from '@fortawesome/fontawesome-free-solid'

class Button extends React.Component {
    constructor(props) {
        super(props);
    }
    
    render () {
        return (
            <div className="rc-btn-div">
                {this.props.link && 
                    <a href={this.props.link} className={this.props.extraclass ? `btn rc-btn ${this.props.extraclass}` : 'btn rc-btn'}
                    target={this.props.target ? this.props.target : ''}
                    >
                        {this.props.text} 
                        {this.props.action &&
                            <FontAwesomeIcon icon={faChevronRight} />
                        }
                    </a>
                }

                {!this.props.link && 
                    <button className={this.props.extraclass ? `btn rc-btn ${this.props.extraclass}` : 'btn rc-btn'}>
                        {this.props.text} 
                        {this.props.action &&
                            <FontAwesomeIcon icon={faChevronRight} />
                        }
                    </button>
                }
            </div>
        );
    }
}

export default Button



// WEBPACK FOOTER //
// ./src/components/button.js